/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAdmissions } from 'app/entities/admission/admission.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getPrescriptions } from 'app/entities/prescription/prescription.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { DischargeType } from 'app/shared/model/enumerations/discharge-type.model';
import { DischargeStatus } from 'app/shared/model/enumerations/discharge-status.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './discharge-summary.reducer';

export const DischargeSummaryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const admissions = useAppSelector(state => state.admission.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const prescriptions = useAppSelector(state => state.prescription.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const dischargeSummaryEntity = useAppSelector(state => state.dischargeSummary.entity);
  const loading = useAppSelector(state => state.dischargeSummary.loading);
  const updating = useAppSelector(state => state.dischargeSummary.updating);
  const updateSuccess = useAppSelector(state => state.dischargeSummary.updateSuccess);
  const dischargeTypeValues = Object.keys(DischargeType);
  const dischargeStatusValues = Object.keys(DischargeStatus);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/discharge-summary${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAdmissions({}));
    dispatch(getGlucoUsers({}));
    dispatch(getPrescriptions({}));
    dispatch(getDoctors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.nextVisit !== undefined && typeof values.nextVisit !== 'number') {
      values.nextVisit = Number(values.nextVisit);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.normalcyAfter !== undefined && typeof values.normalcyAfter !== 'number') {
      values.normalcyAfter = Number(values.normalcyAfter);
    }

    const entity = {
      ...dischargeSummaryEntity,
      ...values,
      admission: admissions.find(it => it.id.toString() === values.admission?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      prescription: prescriptions.find(it => it.id.toString() === values.prescription?.toString()),
      approvedBy: doctors.find(it => it.id.toString() === values.approvedBy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          dischargeType: 'REGULAR_DISCHARGE',
          dischargeStatus: 'SUMMERY_ADDED',
          intiitiatedByType: 'ACCOUNTANT',
          modifiedByType: 'ACCOUNTANT',
          ...dischargeSummaryEntity,
          admission: dischargeSummaryEntity?.admission?.id,
          patient: dischargeSummaryEntity?.patient?.id,
          prescription: dischargeSummaryEntity?.prescription?.id,
          approvedBy: dischargeSummaryEntity?.approvedBy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.dischargeSummary.home.createOrEditLabel" data-cy="DischargeSummaryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.dischargeSummary.home.createOrEditLabel">Create or edit a DischargeSummary</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="discharge-summary-id"
                  label={translate('tinyMedicRestApp.dischargeSummary.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.summaryoftreatment')}
                id="discharge-summary-summaryoftreatment"
                name="summaryoftreatment"
                data-cy="summaryoftreatment"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.admissiondiagnosis')}
                id="discharge-summary-admissiondiagnosis"
                name="admissiondiagnosis"
                data-cy="admissiondiagnosis"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.finaldiagnosis')}
                id="discharge-summary-finaldiagnosis"
                name="finaldiagnosis"
                data-cy="finaldiagnosis"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.previousmedicines')}
                id="discharge-summary-previousmedicines"
                name="previousmedicines"
                data-cy="previousmedicines"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.treatementmedicines')}
                id="discharge-summary-treatementmedicines"
                name="treatementmedicines"
                data-cy="treatementmedicines"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.emergencyPlan')}
                id="discharge-summary-emergencyPlan"
                name="emergencyPlan"
                data-cy="emergencyPlan"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.nextVisit')}
                id="discharge-summary-nextVisit"
                name="nextVisit"
                data-cy="nextVisit"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.active')}
                id="discharge-summary-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.timestampentry')}
                id="discharge-summary-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.microSec')}
                id="discharge-summary-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.lastupdated')}
                id="discharge-summary-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.cursor')}
                id="discharge-summary-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.dischargeType')}
                id="discharge-summary-dischargeType"
                name="dischargeType"
                data-cy="dischargeType"
                type="select"
              >
                {dischargeTypeValues.map(dischargeType => (
                  <option value={dischargeType} key={dischargeType}>
                    {translate(`tinyMedicRestApp.DischargeType.${dischargeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.dischargeStatus')}
                id="discharge-summary-dischargeStatus"
                name="dischargeStatus"
                data-cy="dischargeStatus"
                type="select"
              >
                {dischargeStatusValues.map(dischargeStatus => (
                  <option value={dischargeStatus} key={dischargeStatus}>
                    {translate(`tinyMedicRestApp.DischargeStatus.${dischargeStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.sourceOfHistory')}
                id="discharge-summary-sourceOfHistory"
                name="sourceOfHistory"
                data-cy="sourceOfHistory"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.chiefComplaints')}
                id="discharge-summary-chiefComplaints"
                name="chiefComplaints"
                data-cy="chiefComplaints"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.historyOfPresentIllness')}
                id="discharge-summary-historyOfPresentIllness"
                name="historyOfPresentIllness"
                data-cy="historyOfPresentIllness"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.medicalHistory')}
                id="discharge-summary-medicalHistory"
                name="medicalHistory"
                data-cy="medicalHistory"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.familyHistory')}
                id="discharge-summary-familyHistory"
                name="familyHistory"
                data-cy="familyHistory"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.historyOfAllergies')}
                id="discharge-summary-historyOfAllergies"
                name="historyOfAllergies"
                data-cy="historyOfAllergies"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.historyOfImmunization')}
                id="discharge-summary-historyOfImmunization"
                name="historyOfImmunization"
                data-cy="historyOfImmunization"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.systemicExamination')}
                id="discharge-summary-systemicExamination"
                name="systemicExamination"
                data-cy="systemicExamination"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.discussion')}
                id="discharge-summary-discussion"
                name="discussion"
                data-cy="discussion"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.dietInstructions')}
                id="discharge-summary-dietInstructions"
                name="dietInstructions"
                data-cy="dietInstructions"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.followupInstructions')}
                id="discharge-summary-followupInstructions"
                name="followupInstructions"
                data-cy="followupInstructions"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.physicalActivityInstructions')}
                id="discharge-summary-physicalActivityInstructions"
                name="physicalActivityInstructions"
                data-cy="physicalActivityInstructions"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.normalcyAfter')}
                id="discharge-summary-normalcyAfter"
                name="normalcyAfter"
                data-cy="normalcyAfter"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.surgicalWoundClear')}
                id="discharge-summary-surgicalWoundClear"
                name="surgicalWoundClear"
                data-cy="surgicalWoundClear"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.painScore')}
                id="discharge-summary-painScore"
                name="painScore"
                data-cy="painScore"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.vitalsStable')}
                id="discharge-summary-vitalsStable"
                name="vitalsStable"
                data-cy="vitalsStable"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.ambulatory')}
                id="discharge-summary-ambulatory"
                name="ambulatory"
                data-cy="ambulatory"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.intiitiatedById')}
                id="discharge-summary-intiitiatedById"
                name="intiitiatedById"
                data-cy="intiitiatedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.modifiedById')}
                id="discharge-summary-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.intiitiatedByType')}
                id="discharge-summary-intiitiatedByType"
                name="intiitiatedByType"
                data-cy="intiitiatedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.dischargeSummary.modifiedByType')}
                id="discharge-summary-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="discharge-summary-admission"
                name="admission"
                data-cy="admission"
                label={translate('tinyMedicRestApp.dischargeSummary.admission')}
                type="select"
              >
                <option value="" key="0" />
                {admissions
                  ? admissions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="discharge-summary-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.dischargeSummary.patient')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="discharge-summary-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.dischargeSummary.prescription')}
                type="select"
              >
                <option value="" key="0" />
                {prescriptions
                  ? prescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="discharge-summary-approvedBy"
                name="approvedBy"
                data-cy="approvedBy"
                label={translate('tinyMedicRestApp.dischargeSummary.approvedBy')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/discharge-summary" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DischargeSummaryUpdate;
